var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1795_33090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50011 2.70791C6.50075 2.49126 6.45806 2.27667 6.37455 2.07676C6.29104 1.87685 6.1684 1.69566 6.01384 1.54384C5.85928 1.39202 5.67592 1.27264 5.47455 1.19273C5.27318 1.11281 5.05786 1.07396 4.84125 1.07848C4.62465 1.08299 4.41114 1.13078 4.21327 1.21902C4.0154 1.30726 3.83718 1.43417 3.68908 1.5923C3.54098 1.75043 3.426 1.93657 3.35089 2.13979C3.27578 2.343 3.24207 2.55919 3.25174 2.77562C2.93335 2.85749 2.63776 3.01073 2.38736 3.22375C2.13696 3.43677 1.93832 3.70397 1.80649 4.00512C1.67465 4.30628 1.61306 4.63348 1.62641 4.96196C1.63975 5.29043 1.72766 5.61157 1.88349 5.90104C1.6095 6.12363 1.39405 6.40979 1.25588 6.73463C1.11771 7.05947 1.061 7.41315 1.09068 7.76491C1.12037 8.11666 1.23555 8.45584 1.42621 8.75293C1.61688 9.05001 1.87724 9.29602 2.18465 9.46954C2.14669 9.76325 2.16935 10.0616 2.25122 10.3462C2.33309 10.6309 2.47244 10.8957 2.66066 11.1243C2.84888 11.353 3.08198 11.5406 3.34556 11.6756C3.60914 11.8106 3.89761 11.8902 4.19314 11.9094C4.48867 11.9286 4.785 11.887 5.06382 11.7871C5.34264 11.6873 5.59804 11.5314 5.81423 11.3289C6.03043 11.1265 6.20283 10.882 6.3208 10.6103C6.43877 10.3387 6.4998 10.0457 6.50011 9.74958V2.70791Z",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 2.70791C6.49937 2.49126 6.54206 2.27667 6.62557 2.07676C6.70908 1.87685 6.83172 1.69566 6.98628 1.54384C7.14084 1.39202 7.3242 1.27264 7.52557 1.19273C7.72694 1.11281 7.94226 1.07396 8.15886 1.07848C8.37547 1.08299 8.58898 1.13078 8.78685 1.21902C8.98472 1.30726 9.16294 1.43417 9.31104 1.5923C9.45914 1.75043 9.57412 1.93657 9.64923 2.13979C9.72434 2.343 9.75805 2.55919 9.74838 2.77562C10.0668 2.85749 10.3624 3.01073 10.6128 3.22375C10.8632 3.43677 11.0618 3.70397 11.1936 4.00512C11.3255 4.30628 11.3871 4.63348 11.3737 4.96196C11.3604 5.29043 11.2725 5.61157 11.1166 5.90104C11.3906 6.12363 11.6061 6.40979 11.7442 6.73463C11.8824 7.05947 11.9391 7.41315 11.9094 7.76491C11.8797 8.11666 11.7646 8.45584 11.5739 8.75293C11.3832 9.05001 11.1229 9.29602 10.8155 9.46954C10.8534 9.76325 10.8308 10.0616 10.7489 10.3462C10.667 10.6309 10.5277 10.8957 10.3395 11.1243C10.1512 11.353 9.91813 11.5406 9.65455 11.6756C9.39097 11.8106 9.10251 11.8902 8.80698 11.9094C8.51145 11.9286 8.21512 11.887 7.9363 11.7871C7.65748 11.6873 7.40208 11.5314 7.18589 11.3289C6.96969 11.1265 6.79729 10.882 6.67932 10.6103C6.56135 10.3387 6.50032 10.0457 6.50001 9.74958V2.70791Z",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 7.04167C7.67024 6.88169 7.27313 6.59046 6.98388 6.20479C6.69464 5.81913 6.52625 5.35636 6.5 4.875C6.47375 5.35636 6.30536 5.81913 6.01612 6.20479C5.72687 6.59046 5.32976 6.88169 4.875 7.04167",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53271 3.52214C9.66381 3.29495 9.73796 3.03941 9.74884 2.77734",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25146 2.77734C3.26218 3.03937 3.33614 3.2949 3.46705 3.52214",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8833 5.902C1.98239 5.82129 2.08843 5.74951 2.20018 5.6875",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 5.6875C10.9115 5.74951 11.0176 5.82129 11.1167 5.902",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25003 9.74825C2.87673 9.74842 2.50972 9.65215 2.18457 9.46875",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8155 9.46875C10.4903 9.65215 10.1233 9.74842 9.75 9.74825",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1795_33090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/Brain.381e088b649c182f42b73d14c605411d.svg";
export { ForwardRef as ReactComponent };